/** Render stored timing; historical step results may predate cumulative retry accounting. */
export default function StepDuration({ durationMs, total = false }: { durationMs?: number; total?: boolean }) {
  const seconds = durationMs === undefined ? undefined : durationMs / 1000
  const formatted = seconds === undefined ? 'Timing unavailable'
    : seconds < 60 ? `${Number(seconds.toFixed(2))}s`
    : `${Math.floor(seconds / 60)}m ${Number((seconds % 60).toFixed(2))}s`
  return <span className="journey-detail__step-detail" title={total ? 'Total elapsed time including retries and recovery' : 'Elapsed time recorded for this step'}>
    {total ? 'Tool time' : 'Step time'}: {formatted}
  </span>
}
